import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import { Trans, useTranslation } from 'react-i18next';

import useCertification from './hooks/useCertification';

function Certification() {
    const { t } = useTranslation('signUp');
    const {
        requestColor, verityColor, onChangeValue, inputValue,
        code, onChangeCode, requestSms, requestVerify,
    } = useCertification();
    const isEmail = useIsEmailSignIn();
    const subtitleKey = isEmail
        ? 'certification.subtitleEmail' : 'certification.subtitle';
    const placeholderKey = isEmail
        ? 'certification.emailPlaceholder' : 'certification.phonePlaceholder';
    return (
        <Container as='section'
            fullWidth
            spacing={12} >
            <Text size='xl' fontWeight='bold'>
                {t('certification.title')}
            </Text>
            <Text color={colors.gray7} fontWeight='bold'
                size='lg'
                css={css`margin-top: 12px`}>
                {t(subtitleKey)}
            </Text>
            <Column fullWidth spacing={12} >
                {/* 전화번호 */}
                <TextField placeholder={t(placeholderKey)}
                    value={inputValue}
                    onChange={onChangeValue}
                    maxLength={isEmail ? 100 : 13}
                    // readOnly={!!certPhoneNo}
                    inputMode={isEmail ? 'email' : 'decimal'}
                    trailing={
                        <ButtonWrapper type='button'
                            onClick={requestSms} >
                            <Text fontWeight='bold' color={requestColor}
                                css={buttonCss} >
                                {t('certification.requestCode')}
                            </Text>
                        </ButtonWrapper>
                    } />
                {/*  인증번호 */}
                <TextField placeholder={t('certification.codePlaceholder')}
                    maxLength={6}
                    value={code}
                    onChange={onChangeCode}
                    // readOnly={isVerified}
                    inputMode='numeric'
                    trailing={
                        <ButtonWrapper type='button'
                            onClick={requestVerify}>
                            <Text fontWeight='bold' color={verityColor}
                                css={buttonCss}>
                                {t('certification.verifyCode')}
                            </Text>
                        </ButtonWrapper>
                    } />
            </Column>
            {/* 정보 제공 */}
            <Row spacing={6}>
                <Text color={colors.gray5}
                    size='s' >
                    <Trans ns='signUp'
                        i18nKey='certification.privacyConsignee'
                        components={{ b: <b/> }} />
                </Text>
                <Divider/>
                <Text color={colors.gray5}
                    size='s' >
                    <Trans ns='signUp'
                        i18nKey='certification.privacyPurpose'
                        components={{ b: <b/> }} />
                </Text>
            </Row>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 50px 20px 36px;
`;

const ButtonWrapper = styled.button`
    padding: 8px 12px;
    background-color: transparent;
`;

const Divider = styled.div`
    background-color: var(--color-gray5);
    height: 8px;
    width: 1px;
`;

const buttonCss = css`
    text-decoration: underline;
    text-underline-offset: 2px;
    cursor: pointer;
`;
export default Certification;
